function getStackKey(prefix) {
  return `${prefix}Stack`
}

export function getStack(prefix) {
  const stack = JSON.parse(sessionStorage.getItem(getStackKey(prefix)) || '[]')
  if (!Array.isArray(stack)) {
    return []
  }
  return stack
}

export function setStack(prefix, valueOrFunction) {
  if (typeof valueOrFunction === 'function') {
    const newValue = valueOrFunction(getStack(prefix))
    if (!Array.isArray(newValue)) {
      throw new Error('Invalid value for setStack')
    }
    sessionStorage.setItem(
      getStackKey(prefix),
      JSON.stringify(
        newValue
      )
    )
    return
  }
  if (!Array.isArray(valueOrFunction)) {
    throw new Error('Invalid value for setStack')
  }
  sessionStorage.setItem(getStackKey(prefix), JSON.stringify(valueOrFunction))
}

export function areStackItemsEqual(item1, item2) {
  const nameMatches = item1.name === item2.name
  const stateMatches = (!item1.state && !item2.state) || (item1.state === item2.state)

  return nameMatches && stateMatches
}

export function removeFromStack(itemToRemove, stack) {
  return stack.filter((item) => !areStackItemsEqual(item, itemToRemove))
}
